import { createTheme } from "@mui/material/styles";

const FONT_FAMILY = "Montserrat, sans-serif";

const muiTheme = createTheme({
  /* ===========================
     GLOBAL TYPOGRAPHY
  ============================ */
  typography: {
    fontFamily: FONT_FAMILY,

    // Optional but recommended: normalize weights
    h1: { fontFamily: FONT_FAMILY },
    h2: { fontFamily: FONT_FAMILY },
    h3: { fontFamily: FONT_FAMILY },
    h4: { fontFamily: FONT_FAMILY },
    h5: { fontFamily: FONT_FAMILY },
    h6: { fontFamily: FONT_FAMILY },
    subtitle1: { fontFamily: FONT_FAMILY },
    subtitle2: { fontFamily: FONT_FAMILY },
    body1: { fontFamily: FONT_FAMILY },
    body2: { fontFamily: FONT_FAMILY },
    caption: { fontFamily: FONT_FAMILY },
    button: {
      fontFamily: FONT_FAMILY,
      textTransform: "none", // optional, keeps UI clean
    },
  },

  /* ===========================
     COMPONENT OVERRIDES
     (ONLY ROOT PRIMITIVES)
  ============================ */
  components: {
    /* ---- Base HTML reset ---- */
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    /* ---- All text rendering ---- */
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    /* ---- All inputs (TextField, Select, Autocomplete) ---- */
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
        input: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
        input: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    MuiFilledInput: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
        input: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    /* ---- Labels (TextField, Checkbox, Radio) ---- */
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    /* ---- Buttons, IconButtons, Chips ---- */
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
        label: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    /* ---- Dropdowns, Menus, Autocomplete options ---- */
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
        option: {
          fontFamily: FONT_FAMILY,
        },
        tag: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    /* ---- Dialogs & Modals ---- */
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },

    /* ---- Tooltips ---- */
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: FONT_FAMILY,
        },
      },
    },
  },
});

export default muiTheme;
